import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import "./Sidemenu.scss";
import { useIntl } from "react-intl";
import { faBars, faCubesStacked, faHome, faClose, faIdCard } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { push } from "connected-react-router";
import { ROUTE_DASHBOARD, ROUTE_HOSTELS, ROUTE_REGISTRATIONS } from "../../app/routes";

const localePrefix = "sidemenu.items.";

export default connect(
	(state) => ({
		...state.router,
	}),
	{}
)(({ location }) => {
	const dispatch = useDispatch();
	const { formatMessage } = useIntl();
	const [showFloater, setShowFloater] = useState(false);
	const [sidemenuItems, setSidemeuItems] = useState([]);

	const toggleFloaterMenu = () => {
		setShowFloater(!showFloater);
	};

	const navigateToDashboard = () => {
		dispatch(
			push({
				pathname: ROUTE_DASHBOARD,
			})
		);
	};

	const navigateToHostels = () => {
		dispatch(
			push({
				pathname: ROUTE_HOSTELS,
			})
		);
	};

	const navigateToRegistrations = () => {
		dispatch(
			push({
				pathname: ROUTE_REGISTRATIONS,
			})
		);
	};

	useEffect(() => {
		if (sidemenuItems.length === 0) {
			setSidemeuItems([
				{
					id: 0,
					icon: faCubesStacked,
					label: "dashboard",
					onClick: navigateToDashboard,
				},
				{
					id: 1,
					icon: faHome,
					label: "hostels",
					onClick: navigateToHostels,
				},
				{
					id: 2,
					icon: faIdCard,
					label: "registrations",
					onClick: navigateToRegistrations,
				},
			]);
		}
	}, []);

	const updateActiveItem = () => {
		console.log(location);
	};

	return (
		<>
			<div className="sidemenu flex direction-col justify-content-start align-items-center mt-36">
				<div className="sidemenu-item flex direction-row align-items-center mt-16" onClick={toggleFloaterMenu}>
					<FontAwesomeIcon icon={faBars} />
				</div>

				{sidemenuItems.map((item) => {
					return (
						<div
							className={`sidemenu-item flex direction-row align-items-center ${
								item.isActive ? "sidemenu-item-active" : ""
							}`}
							onClick={() => {
								updateActiveItem();
								item.onClick();
							}}
						>
							<FontAwesomeIcon icon={item.icon} />
						</div>
					);
				})}
			</div>
			{showFloater && (
				<div className="floater-menu">
					<div
						className="flex direction-row align-items-center justify-content-end"
						onClick={toggleFloaterMenu}
					>
						<FontAwesomeIcon icon={faClose} size={"xl"} style={{ cursor: "pointer" }} />
					</div>

					{sidemenuItems.map((item) => {
						return (
							<div
								className="sidemenu-item  flex direction-row align-items-center justify-content-start mt-8"
								onClick={item.onClick}
							>
								<FontAwesomeIcon icon={item.icon} />
								<div className="text text-body--4 ml-8">
									{formatMessage({ id: `${localePrefix}${item.label}` })}
								</div>
							</div>
						);
					})}
				</div>
			)}
		</>
	);
});
